module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/b23338257a9f7218996f0da6e16b6d6a.png";